<template>
    <v-row>
        <v-col cols="6">
            <v-card outlined elevation="0" class="rounded v-application">
                <v-card-title class="d-flex justify-space-between">
                    <span>Kontakt</span>
                    <add-pharmacy-source
                        :pharmacy_id="pharmacy._id"
                        @get-pharmacy="$emit('get-pharmacy')"
                    />
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row>
                        <v-col cols="auto">
                            <a :href="`tel:${pharmacy.phone}`" @click="addCallHistory">
                                <v-icon size="14" class="mb-1" color="primary">
                                    mdi-phone-classic
                                </v-icon>
                                {{pharmacy.phone}}
                            </a>
                        </v-col>
                        <v-col v-if="pharmacy.mobile" cols="auto">
                            <a :href="`tel:${pharmacy.mobile}`" @click="addCallHistory">
                                <v-icon size="14" color="primary">mdi-phone</v-icon>
                                {{pharmacy.mobile}}
                            </a>

                             <a
                                v-if="whatsappMobileLink"
                                :href="whatsappMobileLink"
                                target="_blank"
                                rel="noopener"
                                title="Chat via WhatsApp"
                                class="ml-1"
                            >
                                <v-icon size="18" color="success">mdi-whatsapp</v-icon>
                            </a>
                        </v-col>
                        <v-col v-if="pharmacy.fax" cols="auto">
                            <v-icon size="14">mdi-fax</v-icon>
                            {{pharmacy.fax}}
                        </v-col>
                        <v-col cols="auto">
                            <a :href="`mailto:${pharmacy.email}`">
                                <v-icon size="14" color="primary">mdi-email</v-icon>
                                {{pharmacy.email}}
                            </a>
                        </v-col>
                        <v-col v-if="pharmacy.email_alt" cols="auto">
                            <a :href="`mailto:${pharmacy.email_alt}`">
                                <v-icon size="14" color="primary">mdi-email</v-icon>
                                {{pharmacy.email_alt}}
                            </a>
                        </v-col>
                        <v-col v-if="pharmacy.email_billing" cols="auto">
                            <a :href="`mailto:${pharmacy.email_billing}`">
                                <v-icon size="14" color="primary">mdi-email</v-icon>
                                {{pharmacy.email_billing}}
                            </a>
                        </v-col>
                        <v-col v-if="pharmacy.website" cols="auto">
                            <a :href="`${pharmacy.website}`" target="_blank">
                                <v-icon size="14" color="primary">mdi-web</v-icon>
                                {{pharmacy.website}}
                            </a>
                        </v-col>
                        <v-col v-if="pharmacy.sources?.length" cols="auto" class="d-flex align-baseline">
                            <v-icon size="14">mdi-database</v-icon>
                            <ul class="sources pl-1">
                                <li v-for="source in pharmacy.sources">
                                    {{ source.name }}
                                </li>
                            </ul>
                        </v-col>
                        <v-col v-if="pharmacy.accommodation" cols="auto">
                            <v-icon size="14">mdi-power-sleep</v-icon>
                            <span>{{ pharmacy.pretty_accommodation }}</span>
                            <span v-if="pharmacy.accommodation == '4'">
                                <span v-if="pharmacy.accommodation_fee">: {{ $n(pharmacy.accommodation_fee, 'currency', 'de-DE') }}</span>
                                <span v-else>: Bitte den Pauschalbetrag mit der Apotheke besprechen und eintragen.</span>
                            </span>
                            <div v-else-if="pharmacy.accommodation == '3' && pharmacy.accommodation_name">
                                '{{ pharmacy.accommodation_name }}'
                            </div>
                        </v-col>
                        <v-col v-if="pharmacy.erp" cols="auto">
                            <v-icon size="14">mdi-briefcase-outline</v-icon>
                            {{ pharmacy.erp }}
                        </v-col>
                        <v-col cols="auto">
                            <v-icon size="14">mdi-currency-eur</v-icon>
                            <span v-if="pharmacy.max_travel_cost">
                                {{ $n(pharmacy.max_travel_cost, 'currency', 'de-DE') }}
                            </span>
                            <span v-else>80 € (Standardwert)</span>
                        </v-col>
                        <v-col cols="auto">
                            <ul>
                                <li>
                                    <span class="font-weight-medium">Wie häufig besteht Personalbedarf?</span>
                                    <span class="ml-1">{{ pharmacy.lead_need_frequency }}</span>
                                </li>
                                <li>
                                    <span class="font-weight-medium">Warum suchen Sie Unterstützung?</span>
                                    <span class="ml-1">{{ pharmacy.lead_need_reason }}</span>
                                </li>
                                <li>
                                    <span class="font-weight-medium">Wie sind Sie auf uns aufmerksam geworden?</span>
                                    <span class="ml-1">{{ pharmacy.lead_referral_source }}</span>
                                </li>
                            </ul>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="3">
            <v-card outlined elevation="0" class="rounded">
                <v-card-title>Kommentare</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row v-if="pharmacy.comment" class="v-application">
                        <v-col cols="auto" class="pr-0">
                            <b>Kommentar:</b>
                        </v-col>
                        <v-col>
                            <span v-html="pharmacy.comment" class="textarea-comment"></span>
                        </v-col>
                    </v-row>
                    <v-row v-if="pharmacy.ma_comment" class="v-application">
                        <v-col cols="auto" class="pr-0">
                            <b>Anmerkung f. Freiberufler:</b>
                        </v-col>
                        <v-col>
                            <span v-html="pharmacy.ma_comment" class="textarea-comment"></span>
                        </v-col>
                    </v-row>
                    <v-row class="mt-0">
                        <v-col class="d-flex justify-space-around">
                            <v-btn
                                @click="openMoreInfoDialog('organizational')"
                                dark
                                fab
                                width="35"
                                height="35"
                                color="pink lighten-2"
                            >
                                <v-icon size="20" dark>mdi-account-group</v-icon>
                            </v-btn>
                            <v-btn
                                @click="openMoreInfoDialog('location')"
                                class="open-location-dialog"
                                dark
                                fab
                                width="35"
                                height="35"
                                color="primary lighten-1"
                            >
                                <v-icon size="20" dark>mdi-map-marker</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-dialog v-model="isDialogOpen" max-width="530px">
                        <component :is="componentToOpen" :pharmacy="pharmacy" />
                    </v-dialog>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="3">
            <v-card outlined elevation="0" class="rounded">
                <v-card-title>Freiberufler</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="fb-list">
                    <v-list class="py-0">
                        <div v-for="(pharmacist, idx) in knownPharmacists" :key="pharmacist.id">
                            <v-list-item>
                                <v-list-item-content class="overflow-visible">
                                    <v-list-item-title class="mr-3">
                                        <a :href="`/pharmacists/${pharmacist._id}`" target="_blank" >
                                            {{ pharmacist.name }}
                                        </a>
                                    </v-list-item-title>
                                    <preference-chip
                                        :favorite="pharmacist.favorite"
                                        :blacklisted="pharmacist.blacklisted"
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider v-if="idx+1 < knownPharmacists.length" />
                        </div>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import axios from 'axios';
import AddPharmacySource from "../AddPharmacySource.vue";
import Organizational from "./Organizational.vue";
import Location from "./Location.vue";
import PreferenceChip from "./PreferenceChip.vue";
import { mapMutations } from 'vuex';

export default {
    data() {
        return {
            isDialogOpen: false,
            componentToOpen: null
        }
    },
    components: {
        AddPharmacySource,
        Organizational,
        Location,
        PreferenceChip
    },
    props: {
        pharmacy: Object,
        knownPharmacists: Array
    },
    emits: ['get-pharmacy'],
    computed: {
        gender() {
            return this.pharmacy.owner_sex == 'f' ? 'Frau' : 'Herr'
        },
        whatsappMobile() {
            const raw = this.pharmacy?.mobile
            if (!raw) return null
            return this.toWhatsappNumber(raw)
        },
        whatsappMobileLink() {
            return this.whatsappMobile ? `https://wa.me/${this.whatsappMobile}` : null
        },
    },
    methods: {
        openMoreInfoDialog(component) {
            this.isDialogOpen = true;
            this.componentToOpen = component;
        },
        toWhatsappNumber(input) {
            let s = String(input).trim().replace(/[^\d+]/g, '')

            if (s.startsWith('00')) s = s.slice(2)
            if (s.startsWith('+')) s = s.slice(1)
            if (s.startsWith('0')) s = `49${s.slice(1)}`

            return s
        },
        async addCallHistory() {
            try {
                const response = await axios.post(`/api/pharmacies/${this.pharmacy._id}/call_history`);
                if (response.status != 200) {
                    throw new Error(response.statusText);
                }
                this.alertSuccess("Call gespeichert");
            }
            catch (error) {
                this.alertError();
            }
        },
        ...mapMutations({
            alertError: "alert/error",
            alertSuccess: "alert/success",
        }),
    },
}
</script>

<style scoped>
.rounded {
    border-radius: 12px !important;
}
.sources {
    list-style-type: none;
    display: inline-block;
}
.fb-list {
    max-height: 200px;
    overflow: auto;
}
.fb-list .v-list-item__content > *, .fb-list .v-list-item__title {
    flex: none !important;
}
</style>

<style>
.textarea-comment {
    white-space: pre-line;
}
.vuetify-wrapper .leaflet-control-zoom a {
    background-color: #fff !important
}
</style>